import React from 'react'
import { Box, Typography, Button, useTheme } from '@mui/material'
import { MdErrorOutline } from 'react-icons/md'
import ERROR_CONSTANTS from '../../../Infrastructure/Constants/errorConstants'
import { errorViewSx } from './styles';

export const ErrorView = ({ onRetry, btnText="Try Again" }) => {
  const theme = useTheme()
  return (
    <Box sx={errorViewSx.container}>
      <MdErrorOutline size={70} color={theme.palette.primary.main} /> 
      <Typography variant="h5" color="primary" sx={errorViewSx.title}>
        Oops! Something went wrong.
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={errorViewSx.message}>
       {ERROR_CONSTANTS.GENERIC_ERROR_VIEW} 
      </Typography>
      {onRetry && (
        <Button 
          variant="contained" 
          sx={{...errorViewSx.button, 
            bgcolor: theme.palette.primary.main, 
            color: "white", 
            '&:hover': { bgcolor: theme.palette.primary.dark } 
          }}
          onClick={onRetry}
        >
          {btnText}
        </Button>
      )}
    </Box>
  )
}